import { Datagrid, List, SelectField, FunctionField } from 'react-admin';

import { configOptions } from '../../constants/choices/config.choices';

const ConfigList = () => (
  <List title='List of Configurations' sort={{ field: 'configType', order: 'ASC' }}>
    <Datagrid rowClick='show' bulkActionButtons={false}>
      <SelectField source='configType' choices={configOptions} label='Configuration Type' />
      <FunctionField
        source='appConfig'
        label='Application Configuration '
        render={(item: any) => JSON.stringify(item.appConfig, null, 2)}
        sx={{ fontFamily: 'monospace', background: '#eee' }}
      />
    </Datagrid>
  </List>
);

export default ConfigList;
